import React, { FunctionComponent } from 'react';
import { PersonShowSidebarHeading } from '../../molecules/personShowSidebarHeading';
import { PersonShowMainAlert } from '../../molecules/personShowMainAlert';
import { PersonShowMainAlertScout } from '../../molecules/personShowMainAlertScout';
import { PersonShowSidebarItem } from '../../molecules/personShowSidebarItem';
import { OccupationItem } from '../../../types/personShow';

type Props = {
  age: string;
  isPc: boolean;
  isSuccessPlan: boolean;
  personId: number;
  noIconPersonImg: string;
  instagramIcon: string;
  twitterIcon: string;
  xIcon: string;
  penIconImg: string;
  icon: string;
  fullName: string;
  follows: number | null;
  gender: string;
  location: string;
  birthday: string;
  graduationYear: string;
  tel: string;
  mail: string;
  instagram: string;
  twitter: string;
  isShow: boolean;
  fromPage: string;
  unCompletedProfile: boolean;
  isStudent: boolean;
  currentOccupations: OccupationItem[];
  salary: number | null;
  positions: string;
  resume: "" | File | { name: { url: string; } };
  jobResume: "" | File | { name: { url: string; } };
  handleOpenModal: (target: string, title: string) => void;
  handleUploadIcon: (file: File) => void;
  offline011: string;
  showOffline011Banner: boolean;
  memo?: string;
  isMemoModalOpen?: boolean;
  handleMemoChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleOpenMemoModal?: () => void;
  handleCloseMemoModal?: () => void;
  isOneYearPassed: boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  age,
  isPc,
  isSuccessPlan,
  personId,
  noIconPersonImg,
  instagramIcon,
  twitterIcon,
  xIcon,
  penIconImg,
  icon,
  fullName,
  follows,
  gender,
  location,
  birthday,
  graduationYear,
  tel,
  mail,
  instagram,
  twitter,
  isShow,
  fromPage,
  unCompletedProfile,
  isStudent,
  currentOccupations,
  salary,
  positions,
  resume,
  jobResume,
  handleOpenModal,
  handleUploadIcon,
  offline011,
  showOffline011Banner,
  memo,
  isMemoModalOpen,
  handleMemoChange,
  handleOpenMemoModal,
  handleCloseMemoModal,
  isOneYearPassed,
}) => {
  const handleClick = (target: string, title: string) => handleOpenModal(target, title);

  // 連絡先・SNSブロック（電話番号 / メールアドレス / Instagram / X）が
  // 1項目でも描画されるかどうか。全て非表示になるケースでは
  // 直前の区切り線（person__show__sidebar--devide）も出さない。
  const shouldDisplayContactSection = () => {
    if (!isPc || fromPage === 'scout' || fromPage === 'companyPeople') return false;
    if (isOneYearPassed) return false;
    const canShowTelMail = !isSuccessPlan && (isShow || !!tel || !!mail);
    const canShowSns = isShow || !!instagram || !!twitter;
    return canShowTelMail || canShowSns;
  };

  return (
    <div className="person__show__sidebar">
      <PersonShowSidebarHeading
        personId={personId}
        instagramIcon={instagramIcon}
        xIcon={xIcon}
        noIconPersonImg={noIconPersonImg}
        icon={icon}
        name={fullName}
        instagram={instagram}
        twitter={twitter}
        follows={follows}
        fromPage={fromPage}
        isShow={isShow}
        positions={positions}
        handleUploadIcon={handleUploadIcon}
        resume={resume}
        jobResume={jobResume}
        handleOpenMemoModal={handleOpenMemoModal}
        isOneYearPassed={isOneYearPassed}
      />

      {/* OFFLINEバナー非表示 */}
      {/* {!isPc && showOffline011Banner && offline011 && (
        <a href="/lp/offline/tokyo" className="offline gtm-offline-view-count" data-event-name="offline on screen" data-event="click" data-category="person_profile" data-value="offline011_banner">
          <img src={offline011} alt="OFFLINEイベントバナー" />
        </a>
      )} */}

      {unCompletedProfile && isShow && !isPc && <PersonShowMainAlert personId={personId} />}
      {!isPc && !isShow && fromPage === 'scout' && <PersonShowMainAlertScout personId={personId} isPc={isPc} />}
      {!isPc && <h2 className="mainTitle">基本情報</h2>}
      <PersonShowSidebarItem penIconImg={penIconImg} title="性別" value={gender} id="gender" handleClick={handleClick} isShow={isShow} word="選択する" />
      <PersonShowSidebarItem penIconImg={penIconImg} title="居住地" value={location} id="location" handleClick={handleClick} isShow={isShow} word="選択する" />
      <PersonShowSidebarItem penIconImg={penIconImg} title="生年月日" value={`${birthday}(${age}歳)`} id="birthday" handleClick={handleClick} isShow={isShow} word="選択する" />
      <PersonShowSidebarItem penIconImg={penIconImg} title="卒業(予定)年" value={graduationYear} id="graduationYear" handleClick={handleClick} isShow={isShow} word="選択する" />

      {!isStudent && (
        <>
          <PersonShowSidebarItem penIconImg={penIconImg} title="直近の職種" value={currentOccupations} id="currentOccupations" handleClick={handleClick} isShow={isShow} word="選択する" />
          {fromPage !== 'companyPeople' && (
            <PersonShowSidebarItem penIconImg={penIconImg} title="直近の年収" value={salary} id="salary" handleClick={handleClick} isShow={isShow} word="選択する" />
          )}
        </>
      )}

      {shouldDisplayContactSection() && <hr className="person__show__sidebar--devide" />}

      {shouldDisplayContactSection() && (
        <>
          {!isSuccessPlan && !isOneYearPassed && (
            <>
              <PersonShowSidebarItem penIconImg={penIconImg} title="電話番号" value={tel} id="tel" handleClick={handleClick} isShow={isShow} word="追加する" />
              <PersonShowSidebarItem penIconImg={penIconImg} title="メールアドレス" value={mail} id="mail" handleClick={(target, title) => { window.location.href = `/users/${personId}/preference/edit?open=email`; }} isShow={isShow} word="追加する" />
            </>
          )}
          {!isOneYearPassed && (
            <>
              <PersonShowSidebarItem penIconImg={penIconImg} title="Instagram" value={instagram} id="instagram" handleClick={handleClick} isShow={isShow} word="追加する" isPc={isPc} />
              <PersonShowSidebarItem penIconImg={penIconImg} title="（旧Twitter）" value={twitter} id="twitter" handleClick={handleClick} isShow={isShow} word="追加する" last />
            </>
          )}
        </>
      )}
    </div>
  );
};
